import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  findAttempt: null,
  findError: ['error'],
  findSuccess: ['entries', 'total']
}, {prefix: "SUBSCRIPTIONS_"});
